<style>
</style>

<template>
    <div class="animated fadeIn">

        <b-alert variant="danger" show>
            {{Core.Definition.getDefinition('Avant d\'effectuer une importation, assurez-vous de faire une sauvegarde de sécurité de votre base de données.')}}
        </b-alert>

        <b-tabs fill>
            <b-tab v-if="Core.Session.AuthUser.can('platform_management')">
                <template slot="title">
                    <i class="fa fa-user mr-2"></i>{{Core.Definition.getDefinition('Localhost')}}
                </template>

                <Request
                        ref="requestImportLocalHost"
                        root="/import/localhost"
                        method="POST"
                        :onRequestSuccess="onRequestImportLocalHostSuccess">
                    <slot slot="body">

                        <InputText
                                :label="Core.Definition.getDefinition('Environnement ID')"
                                v-model="dataImportLocalHost.sourceEnvironmentId">
                        </InputText>

                        <InputText
                                :label="Core.Definition.getDefinition('Base de données')"
                                v-model="dataImportLocalHost.sourceDatabaseName">
                        </InputText>

                        <InputText
                                :label="Core.Definition.getDefinition('Prefix')"
                                v-model="dataImportLocalHost.sourcePrefix">
                        </InputText>

                        Part:
                        <select v-model="dataImportLocalHost.part">
                            <option value="custom">Custom</option>
                            <option value="clear">clear</option>
                            <option value="users">users</option>
                            <option value="userCreditCards">creditcards</option>
                            <option value="products">products</option>
                            <option value="events">events</option>
                            <option value="eventDates">eventDates</option>
                            <option value="orders">orders</option>
                            <option value="recurringSubscriptions">recurringSubscriptions</option>
                            <option value="limitedSubscriptions">limitedSubscriptions</option>
                            <option value="eventDateBookings">eventDateBookings</option>
                            <option value="completePayments">completePayments</option>
                            <option value="all">All</option>
                        </select>
                        <br/>

                        <b-button @click="onImportLocalHostConfirmClick" class="btn btn-success mt-3 ml-2">{{Core.Definition.getDefinition('Confirmer')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>

                    </slot>
                </Request>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-user mr-2"></i>{{Core.Definition.getDefinition('Utilisateurs')}}
                </template>

                <Request
                        ref="requestImportUsers"
                        root="/import/users"
                        method="POST"
                        :onRequestSuccess="onRequestImportUsersSuccess">
                    <slot slot="body">
                        <div v-if="dataImportUser.status === 'fileUpload'">
                            <InputFiles
                                    v-model="dataImportUser.files"
                                    :placeholder="Core.Definition.getDefinition('Téléversez un fichier CSV d\'utilisateurs')"
                                    :multiple="false"
                                    :allowedTypes="['text/csv']"></InputFiles>
                            <hr/>
                            <b-button @click="onImportUserCheckoutClick" class="btn btn-success mt-3">{{Core.Definition.getDefinition('Vérifications')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>
                        </div>
                        <div v-if="dataImportUser.status === 'checkout'">
                            <table class="table table-striped table-responsive">
                                <thead>
                                    <tr>
                                        <th>firstname</th>
                                        <th>lastname</th>
                                        <th>email</th>
                                        <th>phone</th>
                                        <th>mobile</th>
                                        <th>address</th>
                                        <th>city</th>
                                        <th>country</th>
                                        <th>province</th>
                                        <th>zipcode</th>
                                        <th>birthDate</th>
                                        <th>billingAddress</th>
                                        <th>billingCity</th>
                                        <th>billingCountry</th>
                                        <th>billingProvince</th>
                                        <th>billingZipcode</th>
                                        <th>notes</th>
                                        <th>parentId</th>
                                        <th>creationDate</th>
                                        <th>uniqueRef</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in dataImportUser.rows">
                                        <td>{{row.firstname}}</td>
                                        <td>{{row.lastname}}</td>
                                        <td>{{row.email}}</td>
                                        <td>{{row.phone}}</td>
                                        <td>{{row.mobile}}</td>
                                        <td>{{row.address}}</td>
                                        <td>{{row.city}}</td>
                                        <td>{{row.country}}</td>
                                        <td>{{row.province}}</td>
                                        <td>{{row.zipcode}}</td>
                                        <td>{{row.birthDate}}</td>
                                        <td>{{row.billingAddress}}</td>
                                        <td>{{row.billingCity}}</td>
                                        <td>{{row.billingCountry}}</td>
                                        <td>{{row.billingProvince}}</td>
                                        <td>{{row.billingZipcode}}</td>
                                        <td>{{row.notes}}</td>
                                        <td>{{row.parentId}}</td>
                                        <td>{{row.creationDate}}</td>
                                        <td>{{row.uniqueRef}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <b-button @click="onImportUserReturnClick" class="btn btn-light mt-3"><i class="fa fa-chevron-left"></i>&nbsp;{{Core.Definition.getDefinition('Retour')}}</b-button>
                            <b-button @click="onImportUserConfirmClick" class="btn btn-success mt-3 ml-2">{{Core.Definition.getDefinition('Confirmer')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>
                        </div>

                        <div v-if="dataImportUser.status === 'result'">
                            <table class="table table-striped">
                                <thead>
                                    <th>
                                        {{Core.Definition.getDefinition('Importés')}}
                                    </th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {{dataImportUser.count}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <b-button @click="onImportUserReturnClick" class="btn btn-light mt-3">{{Core.Definition.getDefinition('Terminer')}}</b-button>
                        </div>
                    </slot>
                </Request>
            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="fa fa-user mr-2"></i>{{Core.Definition.getDefinition('Produits')}}
                </template>

                <Request
                        ref="requestImportProducts"
                        root="/import/products"
                        method="POST"
                        :onRequestSuccess="onRequestImportProductsSuccess">
                    <slot slot="body">
                        <div v-if="dataImportProduct.status === 'fileUpload'">
                            <InputFiles
                                    v-model="dataImportProduct.files"
                                    :placeholder="Core.Definition.getDefinition('Téléversez un fichier CSV de produits')"
                                    :multiple="false"
                                    :allowedTypes="['text/csv']"></InputFiles>
                            <hr/>
                            <b-button @click="onImportProductCheckoutClick" class="btn btn-success mt-3">{{Core.Definition.getDefinition('Vérifications')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>
                        </div>
                        <div v-if="dataImportProduct.status === 'checkout'">
                            <table class="table table-striped table-responsive">
                                <thead>
                                <tr>
                                    <th>title</th>
                                    <th>type</th>
                                    <th>isTaxable</th>
                                    <th>regularPrice</th>
                                    <th>description</th>
                                    <th>shortDescription</th>
                                    <th>stockManagement</th>
                                    <th>stockQuantity</th>
                                    <th>bookingLimit</th>
                                    <th>bookingLimitManagement</th>
                                    <th>bookingLimitPeriod</th>
                                    <th>bookingLimitInterval</th>
                                    <th>period</th>
                                    <th>periodInterval</th>
                                    <th>periodLength</th>
                                    <th>image</th>
                                    <th>expirationPeriod</th>
                                    <th>expirationPeriodLength</th>
                                    <th>uniqueRef</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="row in dataImportProduct.rows">
                                    <td>{{row.title}}</td>
                                    <td>{{row.type}}</td>
                                    <td>{{row.isTaxable}}</td>
                                    <td>{{row.regularPrice}}</td>
                                    <td>{{row.description}}</td>
                                    <td>{{row.shortDescription}}</td>
                                    <td>{{row.stockManagement}}</td>
                                    <td>{{row.stockQuantity}}</td>
                                    <td>{{row.bookingLimit}}</td>
                                    <td>{{row.bookingLimitManagement}}</td>
                                    <td>{{row.bookingLimitPeriod}}</td>
                                    <td>{{row.bookingLimitInterval}}</td>
                                    <td>{{row.period}}</td>
                                    <td>{{row.periodInterval}}</td>
                                    <td>{{row.periodLength}}</td>
                                    <td>{{row.image}}</td>
                                    <td>{{row.expirationPeriod}}</td>
                                    <td>{{row.expirationPeriodLength}}</td>
                                    <td>{{row.uniqueRef}}</td>
                                </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <b-button @click="onImportProductReturnClick" class="btn btn-light mt-3"><i class="fa fa-chevron-left"></i>&nbsp;{{Core.Definition.getDefinition('Retour')}}</b-button>
                            <b-button @click="onImportProductConfirmClick" class="btn btn-success mt-3 ml-2">{{Core.Definition.getDefinition('Confirmer')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>
                        </div>

                        <div v-if="dataImportProduct.status === 'result'">
                            <table class="table table-striped">
                                <thead>
                                <th>
                                    {{Core.Definition.getDefinition('Importés')}}
                                </th>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        {{dataImportProduct.count}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <b-button @click="onImportProductReturnClick" class="btn btn-light mt-3">{{Core.Definition.getDefinition('Terminer')}}</b-button>
                        </div>
                    </slot>
                </Request>
            </b-tab>

            <b-tab>
                <template slot="title">
                    <i class="fa fa-refresh mr-2"></i>{{Core.Definition.getDefinition('Abonnements')}}
                </template>

                <Request
                        ref="requestImportSubscriptions"
                        root="/import/subscriptions"
                        method="POST"
                        :onRequestSuccess="onRequestImportSubscriptionsSuccess">
                    <slot slot="body">
                        <div v-if="dataImportSubscription.status === 'fileUpload'">
                            <InputFiles
                                    v-model="dataImportSubscription.files"
                                    :placeholder="Core.Definition.getDefinition('Téléversez un fichier CSV d\'abonnement récurrents')"
                                    :multiple="false"
                                    :allowedTypes="['text/csv']"></InputFiles>
                            <hr/>
                            <b-button @click="onImportSubscriptionCheckoutClick" class="btn btn-success mt-3">{{Core.Definition.getDefinition('Vérifications')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>
                        </div>
                        <div v-if="dataImportSubscription.status === 'checkout'">
                            <table class="table table-striped table-responsive">
                                <thead>
                                <tr>
                                    <th>userUniqueRef</th>
                                    <th>productUniqueRef</th>
                                    <th>productIdRef</th>
                                    <th>userIdRef</th>
                                    <th>status</th>
                                    <th>paymentStatus</th>
                                    <th>start</th>
                                    <th>end</th>
                                    <th>notes</th>
                                    <th>bookingCount</th>
                                    <th>bookingRemaining</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="row in dataImportSubscription.rows">
                                    <td>{{row.userUniqueRef}}</td>
                                    <td>{{row.productUniqueRef}}</td>
                                    <td>{{row.userIdRef}}</td>
                                    <td>{{row.productIdRef}}</td>
                                    <td>{{row.status}}</td>
                                    <td>{{row.paymentStatus}}</td>
                                    <td>{{row.start}}</td>
                                    <td>{{row.end}}</td>
                                    <td>{{row.notes}}</td>
                                    <td>{{row.bookingCount}}</td>
                                    <td>{{row.bookingRemaining}}</td>
                                </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <b-button @click="onImportSubscriptionReturnClick" class="btn btn-light mt-3"><i class="fa fa-chevron-left"></i>&nbsp;{{Core.Definition.getDefinition('Retour')}}</b-button>
                            <b-button @click="onImportSubscriptionConfirmClick" class="btn btn-success mt-3 ml-2">{{Core.Definition.getDefinition('Confirmer')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>
                        </div>

                        <div v-if="dataImportSubscription.status === 'result'">
                            <table class="table table-striped">
                                <thead>
                                <th>
                                    {{Core.Definition.getDefinition('Importés')}}
                                </th>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        {{dataImportSubscription.count}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <hr/>
                            <b-button @click="onImportSubscriptionReturnClick" class="btn btn-light mt-3">{{Core.Definition.getDefinition('Terminer')}}</b-button>
                        </div>
                    </slot>
                </Request>

            </b-tab>
            
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import Request from '../../../components/Request'
    import InputFiles from '../../../components/InputFiles'
    import InputText from '../../../components/InputText'
    export default {
        name: 'SettingsImportations',
        components: {
            InputText,
            Request,
            InputFiles
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataImportUser: {
                    status: 'fileUpload',
                    rows: [],
                    files: [],
                    count: 0
                },
                dataImportProduct: {
                    status: 'fileUpload',
                    rows: [],
                    files: [],
                    count: 0
                },
                dataImportSubscription: {
                    status: 'fileUpload',
                    rows: [],
                    files: [],
                    count: 0
                },
                dataImportLocalHost: {
                    status: '',
                    sourceEnvironmentId: '',
                    sourceDatabaseName: '',
                    sourcePrefix: '',
                    part: ''
                }
            }
        },
        computed: {
        },
        methods: {
            onRequestImportUsersSuccess(data) {
                if (data.status !== undefined) {
                    this.dataImportUser.status = data.status
                }
                if (data.rows !== undefined) {
                    this.dataImportUser.rows = data.rows
                }
                if (data.count !== undefined) {
                    this.dataImportUser.rows = data.count
                }
            },
            onImportUserReturnClick() {
                this.dataImportUser.status = 'fileUpload'
                this.dataImportUser.files = []
                this.dataImportUser.rows = []
            },
            onImportUserCheckoutClick() {

                this.dataImportUser.status = 'checkout'

                this.$refs.requestImportUsers.clearArgs()
                this.$refs.requestImportUsers.addArg('files', Core.Value.decode(this.dataImportUser.files, Core.Value.typeFiles))
                this.$refs.requestImportUsers.addArg('status', this.dataImportUser.status)
                this.$refs.requestImportUsers.request()
            },
            onImportUserConfirmClick() {

                this.dataImportUser.status = 'confirm'

                this.$refs.requestImportUsers.clearArgs()
                this.$refs.requestImportUsers.addArg('files', Core.Value.decode(this.dataImportUser.files, Core.Value.typeFiles))
                this.$refs.requestImportUsers.addArg('status', this.dataImportUser.status)
                this.$refs.requestImportUsers.request()
            },
            onRequestImportProductsSuccess(data) {
                if (data.status !== undefined) {
                    this.dataImportProduct.status = data.status
                }
                if (data.rows !== undefined) {
                    this.dataImportProduct.rows = data.rows
                }
                if (data.count !== undefined) {
                    this.dataImportProduct.rows = data.count
                }
            },
            onImportProductReturnClick() {
                this.dataImportProduct.status = 'fileUpload'
                this.dataImportProduct.files = []
                this.dataImportProduct.rows = []
            },
            onImportProductCheckoutClick() {
                this.dataImportProduct.status = 'checkout'
                this.$refs.requestImportProducts.clearArgs()
                this.$refs.requestImportProducts.addArg('files', Core.Value.decode(this.dataImportProduct.files, Core.Value.typeFiles))
                this.$refs.requestImportProducts.addArg('status', this.dataImportProduct.status)
                this.$refs.requestImportProducts.request()
            },
            onImportProductConfirmClick() {

                this.dataImportProduct.status = 'confirm'

                this.$refs.requestImportProducts.clearArgs()
                this.$refs.requestImportProducts.addArg('files', Core.Value.decode(this.dataImportProduct.files, Core.Value.typeFiles))
                this.$refs.requestImportProducts.addArg('status', this.dataImportProduct.status)
                this.$refs.requestImportProducts.request()
            },
            onRequestImportSubscriptionsSuccess(data) {
                if (data.status !== undefined) {
                    this.dataImportSubscription.status = data.status
                }
                if (data.rows !== undefined) {
                    this.dataImportSubscription.rows = data.rows
                }
                if (data.count !== undefined) {
                    this.dataImportSubscription.rows = data.count
                }
            },
            onImportSubscriptionReturnClick() {
                this.dataImportSubscription.status = 'fileUpload'
                this.dataImportSubscription.files = []
                this.dataImportSubscription.rows = []
            },
            onImportSubscriptionCheckoutClick() {
                this.dataImportSubscription.status = 'checkout'
                this.$refs.requestImportSubscriptions.clearArgs()
                this.$refs.requestImportSubscriptions.addArg('files', Core.Value.decode(this.dataImportSubscription.files, Core.Value.typeFiles))
                this.$refs.requestImportSubscriptions.addArg('status', this.dataImportSubscription.status)
                this.$refs.requestImportSubscriptions.request()
            },
            onImportSubscriptionConfirmClick() {

                this.dataImportSubscription.status = 'confirm'

                this.$refs.requestImportSubscriptions.clearArgs()
                this.$refs.requestImportSubscriptions.addArg('files', Core.Value.decode(this.dataImportSubscription.files, Core.Value.typeFiles))
                this.$refs.requestImportSubscriptions.addArg('status', this.dataImportSubscription.status)
                this.$refs.requestImportSubscriptions.request()
            },
            onImportLocalHostConfirmClick() {
                this.$refs.requestImportLocalHost.clearArgs()
                this.$refs.requestImportLocalHost.addArg('sourceEnvironmentId', this.dataImportLocalHost.sourceEnvironmentId)
                this.$refs.requestImportLocalHost.addArg('sourceDatabaseName', this.dataImportLocalHost.sourceDatabaseName)
                this.$refs.requestImportLocalHost.addArg('sourcePrefix', this.dataImportLocalHost.sourcePrefix)
                this.$refs.requestImportLocalHost.addArg('part', this.dataImportLocalHost.part)
                this.$refs.requestImportLocalHost.request()
            },
            onRequestImportLocalHostSuccess(data) {
                if (data.status !== undefined) {
                    this.dataImportLocalHost.status = data.status
                }
            }
        }
    }
</script>
